      <template>
        <div class="container mt-5 block">
<!--          <Loading v-if="data_block==null"/>-->
<!--          <div v-else>-->
<!--            <BlockTable />-->
<!--          </div>-->
          <BlockTable />
        </div>
      </template>

      <script>
      import BlockTable from "@/views/comp_table/block_table";
      // import Loading from "@/views/_frame/loading";

      export default {
        name: "index",
        components: {BlockTable},
        data() {
          return {
            data_block: null
          }
        },
        methods: {
          async getList() {
            let v = this
            // 过滤条目
            let start = 1
            let end = 25
            v.api('blockList', {
              page: start,
              size: end
            }, {
              vue: v,
              key_data: 'data',
            }).then(function (res) {
              // console.log('blocksList', res)
              if (res.code == 200) {
                v.data_block = res.data.blocksList
              }
            })
          }
        },
        created() {
          // this.getList()
        }
      }
      </script>

      <style scoped lang="scss">

      .block {
        padding-bottom: 500px;
      }

      </style>
